import React from 'react';
import { Box, Typography } from '@mui/material';

interface SpinnerProps {
  message?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ message }) => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 3,
    }}
  >
    <Box
      sx={{
        width: '100%',
        maxWidth: 112,
        aspectRatio: '1 / 1',
        flexShrink: 0,
      }}
    >
      <Box
        component="img"
        src="/webatest-loader.svg"
        alt={message ? '' : 'Loading'}
        aria-hidden={message ? true : undefined}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </Box>
    {message && (
      <Typography
        variant="body2"
        color="text.secondary"
        textAlign="center"
        sx={{ width: '100%' }}
        role="status"
        aria-live="polite"
      >
        {message}
      </Typography>
    )}
  </Box>
);

export default Spinner;
